import OrganizationImg from "assets/common/company/organization.png";

const Organization = () => {
    return (
        <div className="flex-1 bg-[#f4f4f4] flex flex-col items-center pb-16 pt-5 responsive1200:pt-0 responsive1200:px-[4%]">
            <p className="py-[35px] text-[#333] text-[28px] font-[500] responsive1200:py-[30px] responsive1200:text-[24px]">조직도</p>
            <div className="bg-white w-full max-w-[1200px] p-[50px] flex items-center justify-center animate-fade-in">
                <img src={OrganizationImg} alt="organization" loading="lazy" className="w-full" />
            </div>
        </div>
    );
};

export default Organization;
